import { configure } from 'vue-gtag'

export default function () {
  const initGTag = (googleTagId) => {
    configure({
      tagId: googleTagId
    })
  }

  return {
    initGTag
  }
}
